// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"78":"d5145b63","518":"6c327403","649":"b4ff31fd","859":"321fafa1"}[chunkId] + ".chunk.css";
};